import getFullTable from 'src/utils/entityOperations/getFullTable';
/**
 * @T type of the row whose Column is being processed
 * @F type of the row of the table that is referenced by the Column
 */
export default function getColReferenceDataArray(colReferences, ctx, cellProps) {
    const { col } = cellProps;
    let arr = [];
    if (Array.isArray(colReferences)) {
        arr = colReferences;
    }
    else if (typeof colReferences === 'string') {
        arr = getFullTable(colReferences);
    }
    else if (typeof colReferences === 'function') {
        arr = colReferences(ctx, cellProps);
    }
    else if (col.possibleValues) {
        arr = col.possibleValues;
    }
    return arr;
}
